import { WelcomeContainer } from './styles';
import FormSelectSearchable from '@components/Form/FormSelectSearchable';
import FormTextInput from '@components/Form/FormTextInput';
import { useCallback, useEffect, useState } from 'react';
import { useInternationalAccessStore } from '@src/store/admin/international-access';
import { ComponentLoading } from '@components/Loading';
import EditIcon from '@mui/icons-material/Edit';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { PAYMENT_TILES, COUNTRIES_LIST } from '@helper/constants/international';
import { useForm } from 'react-hook-form';
import { Button, FormGroupCheckbox } from 'nsw-ds-react';
import HookFormGroupCheckbox from './components/HookFormGroupCheckbox'
import RecActivitiesAccess from './components/recActivities'

const defaultForm = {
    label: "",
    SK: "",
    countries: "",
	displaySK: "/"
};

const InternationalAccessEdit = () => {
  const store = useInternationalAccessStore((s) => s);
  const getPaymentTilesOptions = useInternationalAccessStore((s) => s.getPaymentTilesOptions);
	const receivableActivities = useInternationalAccessStore((s) => s.receivableActivities);
  const [selectedPaymentTile, setSelectedPaymentTile] = useState({});
	const navigate = useNavigate();
  const { id } = useParams();

  const decodedSK = decodeURIComponent(id);
	const page = PAYMENT_TILES.find(tiles => tiles.SK === decodedSK).page

  useEffect(() => {
    const fetchData = async () => {
      const paymentTilesCountries = await getPaymentTilesOptions();
      const result = PAYMENT_TILES.map(tile => {
        const match = paymentTilesCountries.find(t => t.SK === tile.SK);
        return {
          ...tile,
          countries: match ? match.countries : []
        };
      });

      const foundPaymentTile = result.find(tile => tile.SK === decodedSK);
      // Add displaySK property that always starts with "/"
      if (foundPaymentTile) {
        foundPaymentTile.displaySK = '/' + foundPaymentTile.SK;
      }
      setSelectedPaymentTile(foundPaymentTile);

      hookForm.reset({
        label: foundPaymentTile?.label || '',
        SK: foundPaymentTile?.SK || '',
        displaySK: '/' + foundPaymentTile?.displaySK || '/',
        countries: foundPaymentTile?.countries || [],
      });
    };
  
    fetchData();
  }, []);

  const hookForm = useForm({
      defaultValues: defaultForm,
    });
	const { handleSubmit } = hookForm;

	const submitFilter = (params) => {
    store.updatePaymentTileInternationalList(params.SK, params.countries)
		
  };

  return (
    <WelcomeContainer>
      <section className="main-content">
				<>
				<div className="row">
					<div className="tw-flex tw-justify-center tw-items-center tw-w-full tw-h-40">
						<Button
							as="secondary"
							onClick={(e) => {
								navigate('/admin/international-access');
							}}
						>Back</Button>
						<Button type="submit" onClick={handleSubmit(submitFilter)}>Update</Button>
					</div>
				</div>
				<div className="row">
					<FormTextInput
						hookForm={hookForm}
						name="label"
						label="Payment Tile"
						placeholder="Payment Tile"
						// @ts-ignore
						defaultValue={selectedPaymentTile.label}
						disabled={true}
					/>
				</div>
				<div className="row">
					<FormTextInput
						hookForm={hookForm}
						name="SK"
						label="Payment Tile Path"
						placeholder="Path"
						// @ts-ignore
						defaultValue={
							selectedPaymentTile.displaySK
						}
						disabled={true}
					/>
				</div>
        <div className="row">
					<HookFormGroupCheckbox
						hookForm={hookForm}
						name="countries"
						label="Allowed Countries"
						options={COUNTRIES_LIST}
					/>
        </div>
				<div className="row" style={{ minHeight: 100 }}>
					{page !== "" ? <RecActivitiesAccess page={page}/> : <div className="row">
      				</div>}
				</div>
				</>
      </section>
    </WelcomeContainer>
  );
};

export default InternationalAccessEdit;
